<template>
  <ContentInfoLinks :links="links" />
</template>

<script>
import ContentInfoLinks from 'chimera/all/themes/blueflow/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      links: [
        {
          title: 'Algemeen',
          to: '/schilder-informatie/',
        },
        {
          title: 'Zelf schilderen',
          to: '/schilder-informatie/zelf-schilderen',
        },
        {
          title: 'Veelgestelde vragen',
          to: '/schilder-informatie/veelgestelde-vragen',
        },
      ],
    }
  },
}
</script>
